import React from 'react';
import { arrayOf, shape, bool } from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

export const InfoDrawerBody = ({ info, isAccordion }) => {
  return (
    <div className="sui-mt-2">
      {info?.map(({ title, sections, hideTitleInAccordion }, infoIndex) => {
        const isLastInfo = info?.length - 1 === infoIndex;
        const hasNoSections = sections?.length === 0;
        const hideTitle = isAccordion && hideTitleInAccordion;
        return (
          <div
            className={`sui-flex sui-flex-col sui-mb-3 ${isLastInfo && hasNoSections ? '!sui-mb-0' : ''}`}
            key={`info-${title}`}
          >
            {title && !hideTitle && (
              <div
                className={`sui-mb-3 ${hasNoSections ? '!sui-mb-0' : ''}`}
              >
                <Typography variant="h6" height="normal">
                  {title}
                </Typography>
              </div>
            )}
            {sections?.map((section, sectionIndex) => {
              const { header = '', text = '', list = [] } = section;
              const isLastSection = sections?.length - 1 === sectionIndex;
              const sectionMargin = `sui-mb-3 ${isLastInfo && isLastSection ? '!sui-mb-0' : ''}`;

              return (
                <div key={`section-${header}-${sectionIndex}`}>
                  {header && (
                    <div className={sectionMargin}>
                      <Typography variant="body-base" height="normal">
                        {header}
                      </Typography>
                    </div>
                  )}
                  {text && (
                    <div className={sectionMargin}>
                      <Typography variant="body-base" height="normal">
                        {text}
                      </Typography>
                    </div>
                  )}
                  {!!list?.length && (
                    <div className={sectionMargin}>
                      <ul className="sui-list-disc sui-pl-6" role="presentation">
                        {list?.map((listItem) => {
                          return (
                            <li key={`list-${listItem}`}>
                              <Typography variant="body-base" height="normal">
                                {listItem}
                              </Typography>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

InfoDrawerBody.propTypes = {
  info: arrayOf(shape({})).isRequired,
  isAccordion: bool
};
InfoDrawerBody.defaultProps = {
  isAccordion: false
};
InfoDrawerBody.displayName = 'InfoDrawerBody';